import { useState } from "react";
import { Link } from "react-router-dom";
import certifiedCourseData from "../../data/certifiedCoursesData";
import { publicAsset } from "../../utils/publicAssets";
import "./CertifiedPage.css";

const MA_APPLY_URL = "https://admissions.eusbd.eu/esbd-apply/MA-GBSL/";

const programmesFromData = certifiedCourseData
  .filter((c) => c.showonhomepage === true && c.id !== "project-management-associate")
  .map((c, index) => ({
    featured: index === 0,
    badge: index === 0 ? "Most Popular" : "Certified",
    id: c.id,
    title: (c.title || "").trim(),
    text: c.miniblabforhomepage || "",
    tags: c.school ? [c.school.replace("Faculty of ", "")] : [],
    image:
      typeof c.backgroundImage === "string" && c.backgroundImage.startsWith("http")
        ? c.backgroundImage
        : publicAsset(c.backgroundImage || ""),
    fallback: "linear-gradient(135deg, #0C1F3F, #142d54, #C5A44E)",
    href: `/certified/${c.id}`,
  }));

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CtaArrow = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 12L12 4M12 4H6M12 4v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function CertifiedPage() {
  const [imgErrors, setImgErrors] = useState({});

  const handleImgError = (key) => {
    setImgErrors((prev) => ({ ...prev, [key]: true }));
  };

  return (
    <div className="certified-page">
      <div className="cp-hero">
        <div className="cp-hero__eyebrow">Professional Development</div>
        <h1 className="cp-hero__title">Certified Professional Programmes</h1>
        <p className="cp-hero__desc">
          Career-focused postgraduate and professional certificates designed for
          working professionals, consultants, coaches, and project leaders
          seeking globally recognised credentials.
        </p>
        <div className="cp-hero__stats">
          <div className="cp-hero__stat">
            <div className="cp-hero__stat-num">{programmesFromData.length}</div>
            <div className="cp-hero__stat-label">Programmes</div>
          </div>
          <div className="cp-hero__stat">
            <div className="cp-hero__stat-num">100%</div>
            <div className="cp-hero__stat-label">Online Delivery</div>
          </div>
          <div className="cp-hero__stat">
            <div className="cp-hero__stat-num">Flexible</div>
            <div className="cp-hero__stat-label">Study Schedule</div>
          </div>
        </div>
      </div>

      <div className="cp-section">
        <div className="cp-section__header">
          <h2 className="cp-section__title">All Certified Programmes</h2>
          <span className="cp-section__count">
            {programmesFromData.length} Programmes
          </span>
        </div>

        <div className="cp-grid">
          {programmesFromData.map((p, i) => (
            <div
              key={p.id}
              className={`cp-card ${p.featured ? "cp-card--featured" : ""}`}
            >
              <Link
                to={p.href}
                className="cp-card__img"
                style={imgErrors[p.id] ? { background: p.fallback } : undefined}
              >
                {!imgErrors[p.id] && (
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    onError={() => handleImgError(p.id)}
                  />
                )}
                <span
                  className={`cp-card__badge ${p.featured ? "cp-card__badge--gold" : ""}`}
                >
                  {p.featured ? p.badge : "Certified"}
                </span>
              </Link>

              <div className="cp-card__body">
                <Link to={p.href} className="cp-card__title-link">
                  <h3 className="cp-card__title">{p.title}</h3>
                </Link>
                <p className="cp-card__text">{p.text}</p>
                {p.tags.length > 0 && (
                  <div className="cp-card__tags">
                    {p.tags.map((t, j) => (
                      <span key={j} className="cp-card__tag">{t}</span>
                    ))}
                  </div>
                )}
                <div className="cp-card__footer">
                  <Link to={p.href} className="cp-card__cta">
                    Learn More <ArrowIcon />
                  </Link>
                  <a href={MA_APPLY_URL} target="_blank" rel="noreferrer" className="cp-card__apply">
                    Apply Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="cp-bottom">
        <p className="cp-bottom__text">
          Not sure which programme is right for you? Speak with our admissions
          team to discuss your career goals and find the best fit.
        </p>
        <Link to="/admissions" className="cp-bottom__btn">
          Speak With Admissions
          <CtaArrow />
        </Link>
        <p className="cp-bottom__sub">
          Applications open for March 2027 intake
        </p>
      </div>
    </div>
  );
}
